import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import configureEnvStore from "./configureEnvStore";
import { CookiesProvider } from "react-cookie";
import { RouteName } from './constants/Constants';
import { ErrorBoundary } from 'react-error-boundary';
import RootErrorFallback from './components/UI/ErrorBoundary/RootErrorFallback';
import { isPwaExcludedHost, isPwaExcludedRoute, registerServiceWorker, unregisterServiceWorker } from './shared/pwaUtility';

const store = configureEnvStore();

if (window.location.pathname.startsWith(RouteName.CREATE_AND_INVITE)) {
  if (window.location.pathname.includes('%')) {
    window.location.href = decodeURIComponent(window.location.pathname);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CookiesProvider>
    <Provider store={store}>
      <ErrorBoundary FallbackComponent={RootErrorFallback}>
        <App />
      </ErrorBoundary>
    </Provider>
  </CookiesProvider>
);

// Host-excluded (e.g. rc.blitzz.co): no legitimate PWA on this host, so wipe
// any SW left over from a previous visit. Route-excluded (e.g. /hubspot/
// configure on a tenant subdomain): the host still has a valid PWA — just
// don't register a new SW here; leave any existing one alone.
if (isPwaExcludedHost(window.location.host)) {
  unregisterServiceWorker();
} else if (!isPwaExcludedRoute(window.location.pathname)) {
  registerServiceWorker();
}